<template>
  <div id="pagination">
    <div>
      <el-pagination
        background :hide-on-single-page="total==0"
        layout="->,total,slot,prev, pager, next,jumper"
        @current-change="changePage"
        :page-size="pageSize"
        :current-page="currentPage"
        :total="total"
        >
        <span class="el-pagination__total">第{{currentPage}}/{{Math.ceil(total/pageSize)}}页</span>
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    pageSize:{
      type:Number,
      default:10,
    },
    currentPage:{
      type:Number,
      default:1,
    },
    total:{
      type:Number,
      default:0,
    },
  },
  data(){
    return{

    }
  },
  methods:{
    changePage(val){
      this.$emit("current-change",val);
    }
  }
}
</script>
<style lang="less" scoped>

#pagination{
  /deep/.el-pagination.is-background .btn-next,/deep/.el-pagination.is-background .btn-prev{
      margin: 0 4px;
      background-color: white;
      color: #999;
      border:1px solid rgba(210,210,210,1);
      border-radius:4px;
  }
  /deep/.el-pagination__editor.el-input .el-input__inner {
      border:1px solid rgba(210,210,210,1);
      width: 40px;
      border-radius:4px;
  }

  /deep/.el-pagination .el-pager li {
      color: #666666;
      font-size: 14px;
      background: white;
      border:0.5px solid rgba(210,210,210,1);
      margin: 0 4px;
  }

  /deep/.el-pagination .el-pager li:hover{
      color: @themeColor;
  }

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: @themeColor;
    color: #FFF;
    border:0.5px solid @themeColor;
  }

  /deep/.el-pagination__total {
      color: #999999;
      font-size: 12px;
  }

  /deep/.el-pagination__jump {
      color: #666666;
      font-size: 12px;
  }
}
</style>
